
import { createContext, ReactNode } from 'react';

export type AlertSeverity = "success" | "info" | "warning" | "error";

export interface IAlert {
    content: ReactNode;
    timeout?: number;
    severity?: AlertSeverity;
    dismissable?: boolean;
    dismissed?: boolean;
}

export interface IAlertContext {
    alerts: IAlert[],
    addAlert: (alert: { content: ReactNode, timeout?: number, severity?: AlertSeverity, dismissable?: boolean }) => void;
    removeAlert: (alert: IAlert) => void;
}

const AlertContext = createContext<IAlertContext>({
    alerts: [],
    addAlert: () => {},
    removeAlert: () => {}
});

export default AlertContext;